exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".step--data{font-family:Avenir}.step--data .code-res{color:#00adbc}.step--data .title-reserve{font-size:2.6rem;font-family:Avenir-Heavy}@media (max-width:640px){.step--data .title-reserve{font-size:1.9rem}}.step--data .theme--light.v-icon{color:#000}.step--data .avenir{font-family:Avenir-Heavy}", ""]);

// exports
exports.locals = {
	"navy": "#001d38",
	"turquoiseBlue": "#00adbc",
	"white": "#fff",
	"black": "#000",
	"error": "#b71c1c",
	"cancel": "#f75b4a",
	"success": "#7ed321"
};